import moment from "jalali-moment";
import Fields from "@/feature/farmer_fields/Fields";
import MapPoint from "@/feature/weather_station/Components/MapPoint";
import Stations from "@/feature/weather_station/Components/Stations";
import DrawMapPolygon from "@/feature/farmer_fields/DrawMapPolygon";
import StationView from "@/feature/weather_station/Components/StationView";
import CreateOrEditField from "@/feature/farmer_fields/CreateOrEditField";
import MapPolygonView from "@/feature/farmer_fields/components/MapPolygonView";
import StationPayment from "@/feature/weather_station/Components/StationPayment";

export const FarmerType = {
  Draft: "DRAFT",
  Confirmed: "PENDING",
};

export const Service = {
  NutritionProgarm: "NUTRITION_PROGRAM",
  Visit: "VISIT",
  Weather: "WEATHER",
  sowingDate: "SOWING_DATE",
  Fields: "FIELDS",
  WeedLess: "WEEDLESS",
  ChillingRequirement: "CHILLING_REQUIREMENT",
  WeatherActivation: "WEATHER_ACTIVATION",
  FieldRegistration: "FIELD_REGISTRATION",
  SetFieldInfos: "SET_FIELD_INFOS",
  FieldView: "FIELD_VIEW",
  MyFields: "MY_FIELDS",
  HistoricalMaps: "HISTORICAL_MAPS",
  CultivarRecommendation: "CULTIVAR_RECOMMENDATION",
  HarvestRecommendation: "HARVEST_RECOMMENDATION",
  Experiment: "EXPERIMENT",
  WaterSources: "WATER_SOURCES",
  WaterSourcesView: "WATER_SOURCES_VIEW",
  Pools: "POOLS",
  PoolsView: "POOLS_VIEW",
  YieldGaps: "YEILD_GAPS",
  GrowingSeasonField: "GROWING_SEASON_FIELD",
  GrowingSeasonField_ShowConfirm: "GROWING_SEASON_FIELD_SHOW_CONFIRM",
  ChoosePolygonGrowingSeasonField: "CHOOSE_POLYGON_GROWING_SEASON_FIELD",
  saffronIrrigation: "SAFFRON_IRRIGATION",
};

export const QuestionnaireCurrentState = {
  QuestionnaireManagement: "QUESTIONNAIRE_MANAGEMENT",
  QuestionnaireSupport: "QUESTIONNAIRE_SUPPORT",
  QuestionnaireMealPlanWriting: "QUESTIONNAIRE_MEAL_PLAN_WRITING",
  EducationMangement: "EDUCATION_MANAGEMENT",
};

export const VisitCurrentState = {
  VisitSupport: "VISIT_SUPPORT",
  VisitDataProcess: "VISIT_DATA_PROCESS",
  VisitReportWriting: "VISIT_REPORT_WRITING",
  EducationMangement: "EDUCATION_MANAGEMENT",
};

export const QuestionnaireStatus = {
  Processing: "PROCESSING",
  Completed: "COMPLETED",
};

export const VisitStatus = {
  Processing: "PROCESSING",
  Done: "DONE",
  Completed: "COMPLETED",
};

export const VisitSubState = {
  VisitFarmerInquiry: "VISIT_FARMER_INQUIRY",
  VisitFinancialProcessing: "VISIT_FINANCIAL_PROCESSING",
  VisitExpertSelection: "VISIT_EXPERT_SELECTION",
  VisitFulfilment: "VISIT_FULFILMENT",
  visitDone: "VISIT_DONE",
  Null: null,
  VisitCompleted: "VISIT_COMPLETED",
  VisitSent: "VISIT_SENT",
};

export const InvoiceStatus = {
  Pending: "PENDING",
};

export const PaymentStatus = {
  Pending: "pending",
  Success: "success",
};

export const QuestionnaireStatusTimeLineSteps = {
  QuestionnaireChecking: "بررسی پرسشنامه",
  PaymentAwaiting: "در انتظار پرداخت",
  NutritionProgarmWriting: "نگارش برنامه کودی",
  Controlling: "کنترل و تایید",
  Sending: "ارسال به داشبورد",
};

export const VisitStatusTimeLineSteps = {
  RequestProcessing: "پردازش درخواست",
  DesignationExpert: "تعیین کارشناس",
  DoVisit: "انجام بازدید",
  VisitProcessing: "پردازش بازدید  ",
  CompletingReport: "در حال تکمیل گزارش",
  Sending: " ارسال به داشبورد",
};

export const ExperimentStatusTimeLineSteps = {
  RequestProcessing: "پردازش درخواست",
  Measuring: "در حال اندازه گیری",
  WritingReport: "در حال نگارش گزارش",
  Sending: " ارسال به داشبورد کشاورز",
};
export const Colors = {
  stepActive: "visit-circle-shadow",
  stepInActive: "inline-shadow",
};

export const PlanColors = {
  stepActive: "nutrition-program-circle-shadow",
  stepInActive: "inline-shadow",
};

export const LineColors = {
  stepActive: "nutrition-program-circle-shadow",
  stepInActive: "inline-shadow",
};

export const VisitLineColors = {
  stepActive: "visit-circle-shadow",
  stepInActive: "inline-shadow",
};

export const TextColors = {
  stepActive: "text-[#222222]",
  stepInActive: "text-[#AAAAAA]",
};

const ProductColors = {
  "-1": "#1a1207",
  1: "#d6040e",
  2: "#ba261c",
  3: "#a84a57",
  4: "#e42502",
  5: "#f05e00",
  6: "#e0ba6e",
  7: "#9e7c56",
  8: "#d61a39",
  9: "#da792a",
  10: "#da9840",
  11: "#7c8417",
  12: "#c38c4a",
  13: "#ac7348",
  14: "#cb55ad",
  15: "#481c09",
  16: "#cb4e07",
  17: "#1c7c00",
  19: "#393d3e",
  20: "#c10e24",
  21: "#f29909",
  22: "#d47b66",
  23: "#9bb35d",
  24: "#cbc977",
  25: "#f9f4f7",
  26: "#3d8100",
  27: "#bb9878",
  28: "#407713",
  29: "#8135ac",
  30: "#a27e66",
  31: "#fce7bb",
  32: "#de5581",
  33: "#dadfe5",
  34: "#409c14",
  35: "#7d4c57",
  36: "#a5cd52",
  37: "#fff93c",
  38: "#4d6d46",
  40: "#e6b363",
  41: "#d53803",
  42: "#a9b746",
  43: "#412a7b",
  44: "#6a1825",
  45: "#679500",
  46: "#9ccf1c",
  47: "#de3810",
  48: "#567923",
  49: "#8fad5d",
  50: "#e5e6e2",
  51: "#ff6364",
  52: "#50750b",
  53: "#fa7609",
  54: "#f9df5c",
};

export const serviceCardUiHelper = (_) => {
  let uiObject = {
    productImage: "",
    farmName: "",
    expertName: "",
    productName: "",
    area: 0,
    date: "",
    code: "",
    cost: 0,
    paymentStatus: "",
    paymentGatewayURL: "",
    id: null,
  };

  uiObject.productImage = _?.product?.imageUrl || _?.farm?.product?.imageUrl;
  uiObject.farmName = _?.farm?.name;
  _?.expert &&
    (uiObject.expertName =
      Object.keys(_?.expert)?.length === 0
        ? ""
        : _?.expert?.firstName + " " + _?.expert?.lastName);
  uiObject.productName =
    _?.product?.persianName || _?.farm?.product?.persianName;
  uiObject.area = _?.area || _?.farm?.area;
  uiObject.date = moment(_?.createdAt).locale("fa").format("YYYY/M/D");
  uiObject.code = _?.questionnaireCode || _?.visitCode;
  uiObject.cost = _?.invoice?.cost || _?.farm?.cost;
  // _?.invoice?.status بعدا تک تک آرایه ای شود
  uiObject.paymentStatus =
    _?.invoice?.status || _?.invoices?.find((item) => item.status === "PAID")
      ? "PAID"
      : "PENDING";
  uiObject.id = _?.invoice?.id;
  return uiObject;
};
export const laboratoryServiceCardUiHelper = (_) => {
  let uiObject = {
    productImage: "",
    expertName: "",
    experimentType: "",
    productName: "",
    area: 0,
    date: "",
    code: "",
    cost: 0,
    paymentStatus: "",
    paymentGatewayURL: "",
    id: null,
  };

  uiObject.productImage =
    process.env.REACT_APP_ARVAN_S3_BASE_URL + _?.category?.iconURL;
  _?.expert &&
    (uiObject.expertName =
      Object.keys(_?.expert)?.length === 0
        ? ""
        : _?.expert?.firstName + " " + _?.expert?.lastName);
  uiObject.productName = _?.type?.categoryFA;
  uiObject.area = _?.farm?.area;
  uiObject.date = moment(_?.createdAt).locale("fa").format("YYYY/M/D");
  uiObject.code = _?.experimentCode;
  uiObject.cost = _?.invoice?.cost;
  uiObject.paymentStatus = _?.invoice?.status;
  uiObject.id = _?.id;
  uiObject.experimentType = _?.type;
  uiObject.productName = _?.farm?.product?.persianName;
  return uiObject;
};
export const statusTimeLineUiHelper = (data, service) => {
  const { currentState, status, invoice, mealPlanFile, subState } = data;

  if (service === Service.NutritionProgarm) {
    let uiObject = {
      steps: [
        QuestionnaireStatusTimeLineSteps.QuestionnaireChecking,
        QuestionnaireStatusTimeLineSteps.PaymentAwaiting,
        QuestionnaireStatusTimeLineSteps.NutritionProgarmWriting,
        QuestionnaireStatusTimeLineSteps.Controlling,
        QuestionnaireStatusTimeLineSteps.Sending,
      ],
      plancolors: [
        PlanColors.stepInActive,
        PlanColors.stepInActive,
        PlanColors.stepInActive,
        PlanColors.stepInActive,
        PlanColors.stepInActive,
      ],
      linecolors: [
        LineColors.stepInActive,
        LineColors.stepInActive,
        LineColors.stepInActive,
        LineColors.stepInActive,
      ],
      textcolors: [
        TextColors.stepInActive,
        TextColors.stepInActive,
        TextColors.stepInActive,
        TextColors.stepInActive,
        TextColors.stepInActive,
      ],
      showDownloadButton: false,
      pendingPayment: false,
      planDownloadFile: mealPlanFile,
    };
    if (
      (currentState === QuestionnaireCurrentState.QuestionnaireManagement ||
        currentState === QuestionnaireCurrentState.QuestionnaireSupport) &&
      status === QuestionnaireStatus.Processing &&
      mealPlanFile === null
    ) {
      uiObject.plancolors[0] = PlanColors.stepActive;
      uiObject.textcolors[0] = TextColors.stepActive;
    }

    if (
      (currentState === QuestionnaireCurrentState.QuestionnaireManagement ||
        currentState === QuestionnaireCurrentState.QuestionnaireSupport) &&
      status === QuestionnaireStatus.Processing &&
      invoice.status === InvoiceStatus.Pending
    ) {
      uiObject.plancolors[0] = PlanColors.stepActive;
      uiObject.plancolors[1] = PlanColors.stepActive;
      uiObject.textcolors[0] = TextColors.stepActive;
      uiObject.textcolors[1] = TextColors.stepActive;
      uiObject.linecolors[0] = LineColors.stepActive;
    }

    if (
      currentState === QuestionnaireCurrentState.QuestionnaireMealPlanWriting
    ) {
      uiObject.plancolors[0] = PlanColors.stepActive;
      uiObject.plancolors[1] = PlanColors.stepActive;
      uiObject.plancolors[2] = PlanColors.stepActive;
      uiObject.textcolors[0] = TextColors.stepActive;
      uiObject.textcolors[1] = TextColors.stepActive;
      uiObject.textcolors[2] = TextColors.stepActive;
      uiObject.linecolors[0] = LineColors.stepActive;
      uiObject.linecolors[1] = LineColors.stepActive;
      uiObject.pendingPayment = true;
    }

    if (
      (currentState === QuestionnaireCurrentState.EducationMangement ||
        currentState === QuestionnaireCurrentState.QuestionnaireManagement) &&
      status === QuestionnaireStatus.Processing &&
      mealPlanFile !== null
    ) {
      uiObject.plancolors[0] = PlanColors.stepActive;
      uiObject.plancolors[1] = PlanColors.stepActive;
      uiObject.plancolors[2] = PlanColors.stepActive;
      uiObject.plancolors[3] = PlanColors.stepActive;
      uiObject.textcolors[0] = TextColors.stepActive;
      uiObject.textcolors[1] = TextColors.stepActive;
      uiObject.textcolors[2] = TextColors.stepActive;
      uiObject.textcolors[3] = TextColors.stepActive;
      uiObject.linecolors[0] = LineColors.stepActive;
      uiObject.linecolors[1] = LineColors.stepActive;
      uiObject.linecolors[2] = LineColors.stepActive;
      uiObject.pendingPayment = true;
    }

    if (
      currentState === QuestionnaireCurrentState.QuestionnaireManagement &&
      status === QuestionnaireStatus.Completed
    ) {
      uiObject.linecolors[0] = LineColors.stepActive;
      uiObject.linecolors[1] = LineColors.stepActive;
      uiObject.linecolors[2] = LineColors.stepActive;
      uiObject.linecolors[3] = LineColors.stepActive;
      uiObject.plancolors[0] = PlanColors.stepActive;
      uiObject.plancolors[1] = PlanColors.stepActive;
      uiObject.plancolors[2] = PlanColors.stepActive;
      uiObject.plancolors[3] = PlanColors.stepActive;
      uiObject.plancolors[4] = PlanColors.stepActive;
      uiObject.textcolors[0] = TextColors.stepActive;
      uiObject.textcolors[1] = TextColors.stepActive;
      uiObject.textcolors[2] = TextColors.stepActive;
      uiObject.textcolors[3] = TextColors.stepActive;
      uiObject.textcolors[4] = TextColors.stepActive;
      uiObject.pendingPayment = true;
      uiObject.showDownloadButton = true;
    }

    return uiObject;
  }

  if (service === Service.Visit) {
    let uiObject = {
      steps: [
        VisitStatusTimeLineSteps.RequestProcessing,
        VisitStatusTimeLineSteps.DesignationExpert,
        VisitStatusTimeLineSteps.DoVisit,
        VisitStatusTimeLineSteps.VisitProcessing,
        VisitStatusTimeLineSteps.CompletingReport,
        VisitStatusTimeLineSteps.Sending,
      ],
      colors: [
        Colors.stepInActive,
        Colors.stepInActive,
        Colors.stepInActive,
        Colors.stepInActive,
        Colors.stepInActive,
        Colors.stepInActive,
      ],
      visitlinecolors: [
        VisitLineColors.stepInActive,
        VisitLineColors.stepInActive,
        VisitLineColors.stepInActive,
        VisitLineColors.stepInActive,
        VisitLineColors.stepInActive,
      ],
      textcolors: [
        TextColors.stepInActive,
        TextColors.stepInActive,
        TextColors.stepInActive,
        TextColors.stepInActive,
        TextColors.stepInActive,
        TextColors.stepInActive,
      ],
      showDownloadButtonVisit: false,
      isShowExpert: false,
      visitPayment: "payment",
    };
    if (
      (currentState === VisitCurrentState.VisitSupport &&
        subState === VisitSubState.VisitFarmerInquiry &&
        status === VisitStatus.Processing) ||
      (currentState === VisitCurrentState.VisitSupport &&
        subState === VisitSubState.VisitFinancialProcessing &&
        status === VisitStatus.Processing) ||
      (currentState === VisitCurrentState.VisitSupport &&
        subState === VisitSubState.VisitExpertSelection &&
        status === VisitStatus.Done)
    ) {
      uiObject.colors[0] = Colors.stepActive;
      uiObject.textcolors[0] = TextColors.stepActive;
      uiObject.visitPayment = "payment";
      uiObject.isShowExpert = false;
    }
    if (
      currentState === VisitCurrentState.VisitSupport &&
      subState === VisitSubState.VisitExpertSelection &&
      status === VisitStatus.Processing
    ) {
      uiObject.colors[0] = Colors.stepActive;
      uiObject.colors[1] = Colors.stepActive;
      uiObject.textcolors[0] = TextColors.stepActive;
      uiObject.textcolors[1] = TextColors.stepActive;
      uiObject.visitlinecolors[0] = VisitLineColors.stepActive;
      uiObject.visitPayment = "paid";
      uiObject.isShowExpert = false;
    }
    if (
      (currentState === VisitCurrentState.VisitSupport &&
        subState === VisitSubState.VisitFulfilment &&
        status === VisitStatus.Processing) ||
      (currentState === VisitCurrentState.VisitSupport &&
        subState === VisitSubState.visitDone &&
        status === VisitStatus.Done)
    ) {
      uiObject.colors[0] = Colors.stepActive;
      uiObject.colors[1] = Colors.stepActive;
      uiObject.colors[2] = Colors.stepActive;
      uiObject.textcolors[0] = TextColors.stepActive;
      uiObject.textcolors[1] = TextColors.stepActive;
      uiObject.textcolors[2] = TextColors.stepActive;
      uiObject.visitlinecolors[0] = VisitLineColors.stepActive;
      uiObject.visitlinecolors[1] = VisitLineColors.stepActive;
      uiObject.visitPayment = "paid";
      uiObject.isShowExpert = true;
    }
    if (
      currentState === VisitCurrentState.VisitDataProcess &&
      subState === null &&
      status === VisitStatus.Processing
    ) {
      uiObject.colors[0] = Colors.stepActive;
      uiObject.colors[1] = Colors.stepActive;
      uiObject.colors[2] = Colors.stepActive;
      uiObject.colors[3] = Colors.stepActive;
      uiObject.textcolors[0] = TextColors.stepActive;
      uiObject.textcolors[1] = TextColors.stepActive;
      uiObject.textcolors[2] = TextColors.stepActive;
      uiObject.textcolors[3] = TextColors.stepActive;
      uiObject.visitlinecolors[0] = VisitLineColors.stepActive;
      uiObject.visitlinecolors[1] = VisitLineColors.stepActive;
      uiObject.visitlinecolors[2] = VisitLineColors.stepActive;
      uiObject.visitPayment = "paid";
      uiObject.isShowExpert = true;
    }
    if (
      (currentState === VisitCurrentState.VisitReportWriting &&
        subState === null &&
        status === VisitStatus.Processing) ||
      (currentState === VisitCurrentState.EducationMangement &&
        subState === null &&
        status === VisitStatus.Processing) ||
      (currentState === VisitCurrentState.VisitSupport &&
        subState === VisitSubState.VisitCompleted &&
        status === VisitStatus.Processing)
    ) {
      uiObject.colors[0] = Colors.stepActive;
      uiObject.colors[1] = Colors.stepActive;
      uiObject.colors[2] = Colors.stepActive;
      uiObject.colors[3] = Colors.stepActive;
      uiObject.colors[4] = Colors.stepActive;
      uiObject.textcolors[0] = TextColors.stepActive;
      uiObject.textcolors[1] = TextColors.stepActive;
      uiObject.textcolors[2] = TextColors.stepActive;
      uiObject.textcolors[3] = TextColors.stepActive;
      uiObject.textcolors[4] = TextColors.stepActive;
      uiObject.visitlinecolors[0] = VisitLineColors.stepActive;
      uiObject.visitlinecolors[1] = VisitLineColors.stepActive;
      uiObject.visitlinecolors[2] = VisitLineColors.stepActive;
      uiObject.visitlinecolors[3] = VisitLineColors.stepActive;
      uiObject.visitPayment = "paid";
      uiObject.isShowExpert = true;
    }
    if (
      currentState === VisitCurrentState.VisitSupport &&
      subState === VisitSubState.VisitSent &&
      status === VisitStatus.Completed
    ) {
      uiObject.colors[0] = Colors.stepActive;
      uiObject.colors[1] = Colors.stepActive;
      uiObject.colors[2] = Colors.stepActive;
      uiObject.colors[3] = Colors.stepActive;
      uiObject.colors[4] = Colors.stepActive;
      uiObject.colors[5] = Colors.stepActive;
      uiObject.textcolors[0] = TextColors.stepActive;
      uiObject.textcolors[1] = TextColors.stepActive;
      uiObject.textcolors[2] = TextColors.stepActive;
      uiObject.textcolors[3] = TextColors.stepActive;
      uiObject.textcolors[4] = TextColors.stepActive;
      uiObject.textcolors[5] = TextColors.stepActive;
      uiObject.visitlinecolors[0] = VisitLineColors.stepActive;
      uiObject.visitlinecolors[1] = VisitLineColors.stepActive;
      uiObject.visitlinecolors[2] = VisitLineColors.stepActive;
      uiObject.visitlinecolors[3] = VisitLineColors.stepActive;
      uiObject.visitlinecolors[4] = VisitLineColors.stepActive;
      uiObject.showDownloadButtonVisit = true;
      uiObject.visitPayment = "visitReport";
      uiObject.isShowExpert = true;
    }
    return uiObject;
  }

  if (service === Service.Experiment) {
    let uiObject = {
      steps: [
        ExperimentStatusTimeLineSteps.Measuring,
        ExperimentStatusTimeLineSteps.RequestProcessing,
        ExperimentStatusTimeLineSteps.Sending,
        ExperimentStatusTimeLineSteps.WritingReport,
      ],
      colors: [
        Colors.stepInActive,
        Colors.stepInActive,
        Colors.stepInActive,
        Colors.stepInActive,
      ],
      visitlinecolors: [
        VisitLineColors.stepInActive,
        VisitLineColors.stepInActive,
        VisitLineColors.stepInActive,
        VisitLineColors.stepInActive,
      ],
      textcolors: [
        TextColors.stepInActive,
        TextColors.stepInActive,
        TextColors.stepInActive,
        TextColors.stepInActive,
      ],
      showDownloadButtonVisit: false,
      visitPayment: "payment",
    };

    return uiObject;
  }
};

export const distanceContent = (
  service,
  Service,
  showDownloadButton,
  visitPayment
) => {
  if (service === Service.Visit) {
    if (visitPayment === "visitReport") {
      return "";
    }
  }

  if (service === Service.NutritionProgarm) {
    if (showDownloadButton) {
      return "";
    }
  }
};

export const visitPlanButtonContent = (
  service,
  Service,
  visitPayment,
  pendingPayment,
  showDownloadButton
) => {
  if (service === Service.Visit) {
    switch (visitPayment) {
      case "payment":
        return "پرداخت";

      case "paid":
        return "پرداخت شد !";

      case "visitReport":
        return "دریافت گزارش بازدید";

      default:
        return "نامشخص";
    }
  }

  if (service === Service.NutritionProgarm) {
    if (showDownloadButton) {
      return "مشاهده برنامه کودی";
    } else if (pendingPayment) {
      return "پرداخت شد !";
    } else {
      return "پرداخت";
    }
  }

  if (service === Service.Experiment) {
    switch (visitPayment) {
      case "payment":
        return "پرداخت";

      case "paid":
        return "پرداخت شد !";

      case "visitReport":
        return "دریافت گزارش بازدید";

      default:
        return "نامشخص";
    }
  }
};

export const disableVisitPlanButton = (
  service,
  Service,
  showDownloadButtonVisit,
  visitPayment,
  showDownloadButton,
  pendingPayment
) => {
  if (
    (service === Service.Visit &&
      !showDownloadButtonVisit &&
      visitPayment === "paid") ||
    (service === Service.NutritionProgarm &&
      !showDownloadButton &&
      pendingPayment)
  ) {
    return true;
  } else {
    return false;
  }
};

export const WeatherStationStates = {
  AddStationIntro: 1,
  MapPoint: 2,
  StationPayment: 3,
  StationView: 4,
  Station: 5,
};

export const weatherStationUiHelper = (
  weatherStationState,
  setWeatherStationState,
  navigate,
  open
) => {
  switch (weatherStationState.state) {
    case WeatherStationStates.AddStationIntro:
      return (
        <Stations open={open} setWeatherStationState={setWeatherStationState} />
      );
    case WeatherStationStates.MapPoint:
      return (
        <MapPoint
          service={weatherStationState.service}
          setWeatherStationState={setWeatherStationState}
          defaultData={weatherStationState.stationObject}
        />
      );
    case WeatherStationStates.StationPayment:
      return (
        <StationPayment
          setWeatherStationState={setWeatherStationState}
          weatherStationId={weatherStationState?.stationObject?.id}
        />
      );
    case WeatherStationStates.StationView:
      return (
        <StationView
          setWeatherStationState={setWeatherStationState}
          weatherStation={weatherStationState}
        />
      );
    case WeatherStationStates.Station:
      navigate(`/weather-station/${weatherStationState?.stationObject?.id}`);
      // return <Station setWeatherStationState={setWeatherStationState} />
      break;
    default:
      <Stations open={open} setWeatherStationState={setWeatherStationState} />;
  }
};

export const calculatePremonitionRobot = (
  weatherStationServices,
  optionsObject,
  smsServiceCost,
  weatherStationBaseCost
) => {
  const costsArray = weatherStationServices
    ?.filter(
      (wss) =>
        optionsObject?.servicesIds.includes(wss?.id) &&
        wss?.id !== 2 &&
        wss?.id !== 1
    )
    ?.map((item) => item?.cost);

  if (costsArray?.length > 0) {
    return threeDigitsSeparator(
      (costsArray.reduce((total, current) => total + current) +
        optionsObject.alertPhoneNumbers.length * smsServiceCost) /
        10
    );
  } else {
    return 0;
  }
};

export const calculateTotalCost = (
  weatherStationServices,
  optionsObject,
  smsServiceCost,
  weatherStationBaseCost
) => {
  const costsArray = weatherStationServices
    ?.filter((wss) => optionsObject?.servicesIds.includes(wss?.id))
    ?.map((item) => item?.cost);

  if (costsArray?.length > 0) {
    return threeDigitsSeparator(
      (costsArray?.reduce((total, current) => total + current) +
        optionsObject?.alertPhoneNumbers.length * smsServiceCost +
        weatherStationBaseCost) /
        10
    );
  } else {
    return 0;
  }
};

export const calculateEditedTotalCost = (
  weatherStationServices,
  optionsObject,
  smsServiceCost,
  purchasedAlertPhoneNumbersCount
) => {
  const costsArray = weatherStationServices
    ?.filter((wss) => optionsObject?.servicesIds.includes(wss?.id))
    ?.map((item) => item?.cost);

  if (
    optionsObject?.alertPhoneNumbers?.length > purchasedAlertPhoneNumbersCount
  ) {
    return threeDigitsSeparator(
      ((costsArray?.length > 0
        ? costsArray?.reduce((total, current) => total + current)
        : 0) +
        (optionsObject.alertPhoneNumbers.length -
          purchasedAlertPhoneNumbersCount) *
          smsServiceCost) /
        10
    );
  }
  if (
    costsArray.length > 0 &&
    optionsObject?.alertPhoneNumbers?.length <= purchasedAlertPhoneNumbersCount
  ) {
    return threeDigitsSeparator(
      costsArray?.reduce((total, current) => total + current) / 10
    );
  } else {
    return 0;
  }
};

export const StationStates = {
  InActive: "INACTIVE",
  Active: "ACTIVE",
  Processing: "PROCESSING",
};

export const stationViewUiHelper = (_) => {
  let uiObject = {
    id: _?.id,
    name: _?.name,
    province: _?.province,
    city: _?.city,
    zone: _?.zone,
    location: _?.location,
    isEnabled: false,
    processing: false,
  };

  if (_?.statusName === StationStates.Active) {
    uiObject.isEnabled = true;
  }
  if (_?.statusName === StationStates.Processing) {
    uiObject.processing = true;
  }

  return uiObject;
};

export const FarmerFieldsStates = {
  AddFieldIntro: 1,
  FieldDetails: 2,
  DrawPolygon: 3,
  FieldsMap: 4,
  FieldCertificate: 5,
  MapPolygonView: 6,
  // StationPayment: 3,
  // StationView: 4,
  // Station: 5,
};

export const FarmerFieldsUiHelper = (
  farmerFieldsState,
  setFarmerFieldsState,
  navigate
) => {
  switch (farmerFieldsState.state) {
    case FarmerFieldsStates.AddFieldIntro:
      return <Fields setFarmerFieldsState={setFarmerFieldsState} />;

    case FarmerFieldsStates.FieldDetails:
      return (
        <CreateOrEditField
          service={farmerFieldsState.service}
          setFarmerFieldsState={setFarmerFieldsState}
          defaultData={farmerFieldsState.defaultData}
          data={farmerFieldsState.fieldObject}
          seasonObject={farmerFieldsState.seasonObject}
        />
      );

    case FarmerFieldsStates.MapPolygonView:
      return (
        <MapPolygonView
          defaultData={farmerFieldsState.defaultData}
          service={farmerFieldsState.service}
          setFarmerFieldsState={setFarmerFieldsState}
          fieldObject={farmerFieldsState.fieldObject}
          seasonObject={farmerFieldsState.seasonObject}
          id={farmerFieldsState.fieldObject.id}
        />
      );

    case FarmerFieldsStates.DrawPolygon:
      return (
        <DrawMapPolygon
          defaultData={farmerFieldsState.defaultData}
          service={farmerFieldsState.service}
          setFarmerFieldsState={setFarmerFieldsState}
          fieldObject={farmerFieldsState.fieldObject}
        />
      );

    case FarmerFieldsStates.FieldsMap:
      navigate(`FieldsMap/${farmerFieldsState?.fieldObject?.id}`);
      break;

    case FarmerFieldsStates.FieldCertificate:
      navigate(`field_certificate/${farmerFieldsState?.fieldObject?.id}`);
      break;

    default:
      return <Fields setFarmerFieldsState={setFarmerFieldsState} />;
  }
};

export const fieldsColorHelper = (productId) => {
  return productId ? ProductColors[`${productId}`] : "#C2C2C2";
};

export const threeDigitsSeparator = (number) =>
  number?.toString()?.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
